'use strict';

var actions = require('./actions'),
    lang = require('../lang');


module.exports = {
    get: function ( direction, callback ) {
        lang.currentProvider = this;
        callback(false, [
            [
                {value: '123', action: actions.numericKeyboard},
                '1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '(', ')',
                {className: 'backspace', action: actions.backspace}
            ],
            [
                {value: 'ABC', action: actions.qwertyKeyboard},
                '!', '@', '#', '$', '%', '^', '?', '*', '\\', '-', '+', ':',
                {value: gettext('Clear'), action: actions.clear}
            ],
            [
                'α', '©', '"', '№', '¤', '«', '§', '&', '{', '}', '=', 'β', ';',
                {value: gettext('Enter'), action: actions.done, className: 'yellowText'}
            ],
            [
                {value: lang.shortNames[lang.active], action: actions.changeLanguage, rowSpan: 2, className: 'lang'},
                '|', '¢', '¥', '£', '€', '[', ']', '<', '>', '\'', '…', '—',
                {value: gettext('Cancel'), action: actions.cancel, className: 'cancel'}
            ],
            [
                ',', '.', '/',
                {value: gettext('Space'), action: actions.space, colSpan: 5, className: 'blueText'},
                '_',
                {value: '', action: actions.moveCaretToLeft, className: 'arrow left'},
                {value: '', action: actions.moveCaretToRight, className: 'arrow right'},
                {value: '', action: actions.moveCaretToStart, className: 'arrow start'},
                {value: '', action: actions.moveCaretToEnd, className: 'arrow end'}
            ]
        ]);
    }
};
